import { Base } from "../../framework/base";
import { EnumHelper } from "../enums";
import { UserGroupListItemUser } from "./userGroupListItemUser";
var UserGroupListItem = /** @class */ (function () {
    function UserGroupListItem(obj) {
        this.id = obj && obj.id || "";
        this.companyCode = obj && obj.companyCode || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.picture = obj && obj.picture || "";
        this.level = obj && obj.level || 0;
        this.levelStr = EnumHelper.UserGroupAuthorizationLevelToStr(this.level);
        this.users = Base.getTypedArray(obj ? obj.users : null, UserGroupListItemUser);
    }
    UserGroupListItem.prototype.getTitle = function () {
        return this.name;
    };
    UserGroupListItem.sortUserGroupListItems = function (items, column, asc) {
        if (!items && items.length < 2)
            return items;
        if (column === "name") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        }
        else if (column === "comment") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        }
        else {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.level, b.level)); });
        }
    };
    return UserGroupListItem;
}());
export { UserGroupListItem };
